import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { components } from 'react-select';
export default /*#__PURE__*/React.memo(_ref => {
  let {
    children,
    selectProps,
    ...props
  } = _ref;
  const {
    numSelectedLiteral
  } = selectProps;
  let [values, input] = children;
  if (Array.isArray(values)) {
    values = numSelectedLiteral.replace('%@', values.length);
  }
  return /*#__PURE__*/React.createElement(components.ValueContainer, _extends({}, props, {
    selectProps: selectProps
  }), /*#__PURE__*/React.createElement(components.SingleValue, props, values), input);
});